export default __webpack_public_path__ + "static/Jack(1)-4c9a03efe5a3f0bd561d627c6d87a692.png";